import { UI } from '@genial/components';
import React from 'react';

export interface AssetLoadingCardProps {
  index: number;
}

export const AssetLoadingCard: React.FC<AssetLoadingCardProps> = ({ index }) => {
  return (
    <UI.ProductCard
      testId={`productAccordionLoading-${index}`}
      loading={true}
      color="brand.primary.lightest"
      product={{ name: '', percentage: 0, value: 0 }}
    />
  );
};
